import { jsxs as o, Fragment as R, jsx as r } from "react/jsx-runtime";
import { useState as C, useEffect as f } from "react";
import m from "./personal-information.module.less.js";
import { useForm as Y } from "react-hook-form";
import { HookFormInputField as p } from "../../../../../components/form-elements/hook-form/hook-form-input-field.js";
import { useTranslation as B } from "react-i18next";
import { swedishSnn12NumbersWithoutDash as U, swedishMobilePhoneNumberRegexWithoutCountryCode as x, emailRegex as w } from "../../../../../utilities/validation.js";
import { TrailerRentalSummary as G } from "../trailer-rental-summary/trailer-rental-summary.js";
import "dayjs";
import { isArrayWithItems as h } from "../../../../../helpers/array-helper.js";
import { insertDashIntoSsn as V } from "../../../../../helpers/text-helper.js";
import "../../../../../contexts/global-context.js";
import "motion/react";
import { PrimaryButton as q } from "../../../../../components/elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import { LinkButton as K } from "../../../../../components/elements/link/link.js";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import { usePostTrailerRentalBooking as Q } from "../../../react-query-queries/use-post-trailer-rental-booking.js";
import { HookFormCheckboxGroup as W } from "../../../../../components/form-elements/hook-form/hook-form-checkbox-group.js";
import { AlertSummary as D } from "../../../../../components/elements/alert-summary/alert-summary.js";
import { getErrorsFromHookFormError as j } from "../../../../../helpers/form-helper.js";
import "usehooks-ts";
import "react-countup";
import "embla-carousel-react";
import "react-loading-skeleton";
/* empty css                                                                   */
import "@tanstack/react-query";
import "lodash-es";
import "../../../../../components/form-elements/input/input.js";
import "../../../../../components/form-elements/file-upload/file-upload.js";
import "../../../../../components/form-elements/select/select.js";
import "@radix-ui/react-slider";
import "../../../../../components/blocks/customer-service/company-forms.js";
import "../../../../../labels/i18n.js";
import "body-scroll-lock";
import "@radix-ui/react-visually-hidden";
import J from "../../../../../events/event-aggregator.js";
import { EVENT as z } from "../../../../../events/event.js";
import "supercluster";
/* empty css                                */
const Ue = ({
  dispatch: c,
  trailer: u,
  station: E,
  fromSlot: s,
  toSlot: n,
  rentalPrice: b,
  rentalTermsLinkUrl: g,
  personalInformationForm: l
}) => {
  const { t: e } = B(), { control: i, watch: _, formState: A, handleSubmit: L } = Y({
    mode: "onSubmit",
    reValidateMode: "onChange",
    defaultValues: {
      ssn: l?.ssn ?? "",
      firstName: l?.firstName ?? "",
      lastName: l?.lastName ?? "",
      phoneNumber: l?.phoneNumber ?? "",
      email: l?.email ?? "",
      acceptTerms: !1
    }
  }), a = {
    ssn: e("SSN"),
    firstName: e("FIRST_NAME"),
    lastName: e("LAST_NAME"),
    phoneNumber: e("PHONE"),
    email: e("EMAIL"),
    acceptTerms: e("TERMS")
  }, { errors: O } = A, T = j(O, a, e), [t, M] = C(null), {
    data: N,
    mutate: F,
    isPending: d,
    error: P,
    isSuccess: y
  } = Q();
  f(() => {
    const { unsubscribe: H } = _((v) => {
      M(v);
    });
    return () => H();
  }, [_]), f(() => {
    y && N && t?.email && (J.publish(z.TRACK_EVENT, {
      event: "book_trailer_submit_success",
      station: E.name,
      pickup_date: s.format("YYYY-MM-DD"),
      return_date: n.format("YYYY-MM-DD"),
      trailer_type: u.title,
      est_price: parseInt(u.fromPrice),
      final_price: b,
      pickup_time: s.format("HH:mm"),
      return_time: n.format("HH:mm")
    }), c({
      type: "BOOKING_COMPLETED",
      payload: { bookingId: N, customerEmail: t.email }
    }), typeof window < "u" && window.scrollTo(0, 0));
  }, [N]);
  const S = () => {
    t && c({
      type: "SET_PERSONAL_INFORMATION_FORM",
      payload: { personalInformationForm: t }
    }), c({
      type: "CHANGE_STEP",
      payload: { step: "SELECT_TIMESLOT_FOR_TRAILER" }
    });
  }, k = async () => {
    F({
      locationId: E.locationId,
      typeId: u.trailerTypeId,
      pickupTime: s ? s?.format("YYYY-MM-DDTHH:mm") : "",
      //API-required format
      returnTime: n ? n?.format("YYYY-MM-DDTHH:mm") : "",
      customerInfo: {
        ssn: t?.ssn ? V(t.ssn) : "",
        firstName: t?.firstName ?? "",
        lastName: t?.lastName ?? "",
        email: t?.email ?? "",
        mobilePhone: t?.phoneNumber ?? ""
      }
    });
  }, I = [];
  return P && I.push({
    text: e("TRAILER_RENTAL_ERROR_BOOKING_FAILED")
  }), /* @__PURE__ */ o(R, { children: [
    /* @__PURE__ */ o("div", { className: m.wrapper, children: [
      /* @__PURE__ */ o("div", { className: m.inputFieldWrapper, children: [
        /* @__PURE__ */ r(
          p,
          {
            name: "ssn",
            control: i,
            label: a.ssn,
            helperText: e("SSN_FORMAT"),
            rules: {
              required: { message: e("INPUT_FIELD_REQUIRED"), value: !0 },
              pattern: {
                message: e("INPUT_FIELD_SSN_VALIDATION_FAILED"),
                value: U
              }
            },
            inputMode: "numeric"
          }
        ),
        /* @__PURE__ */ o("div", { className: m.grid50_50, children: [
          /* @__PURE__ */ r(
            p,
            {
              name: "firstName",
              control: i,
              label: a.firstName,
              rules: { required: { message: e("INPUT_FIELD_REQUIRED"), value: !0 } },
              autoComplete: "given-name"
            }
          ),
          /* @__PURE__ */ r(
            p,
            {
              name: "lastName",
              control: i,
              label: a.lastName,
              rules: { required: { message: e("INPUT_FIELD_REQUIRED"), value: !0 } },
              autoComplete: "family-name"
            }
          )
        ] }),
        /* @__PURE__ */ r(
          p,
          {
            name: "phoneNumber",
            control: i,
            label: a.phoneNumber,
            helperText: e("PHONE_FORMAT"),
            rules: {
              required: { message: e("INPUT_FIELD_REQUIRED"), value: !0 },
              pattern: {
                message: e("INPUT_FIELD_PHONE_VALIDATION_FAILED"),
                value: x
              }
            },
            inputMode: "tel",
            autoComplete: "tel"
          }
        ),
        /* @__PURE__ */ r(
          p,
          {
            name: "email",
            control: i,
            label: a.email,
            helperText: e("TRAILER_RENTAL_EMAIL_CONFIRMATION_HELPER"),
            rules: {
              required: { message: e("INPUT_FIELD_REQUIRED"), value: !0 },
              pattern: { message: e("INPUT_FIELD_EMAIL_VALIDATION_FAILED"), value: w }
            },
            inputMode: "email",
            autoComplete: "email"
          }
        ),
        /* @__PURE__ */ r(
          W,
          {
            name: "acceptTerms",
            control: i,
            label: a.acceptTerms,
            checkboxes: [
              {
                name: "acceptTerms",
                label: /* @__PURE__ */ o(R, { children: [
                  "Jag har läst och accepterar",
                  " ",
                  /* @__PURE__ */ r("a", { target: "_blank", href: g, rel: "noreferrer", children: "hyresvillkoren" }),
                  " ",
                  "(öppnas i nytt fönster)"
                ] })
              }
            ],
            rules: { required: { message: e("INPUT_FIELD_REQUIRED"), value: !0 } }
          }
        )
      ] }),
      /* @__PURE__ */ r(G, { station: E, trailer: u, fromSlot: s, toSlot: n })
    ] }),
    /* @__PURE__ */ o("div", { className: m.submitWrapper, children: [
      h(I) && /* @__PURE__ */ r(D, { type: "error", heading: e("ERROR_GENERIC_API_ERROR_HEADING"), messages: I }),
      h(T) && /* @__PURE__ */ r(D, { type: "error", heading: e("ERROR_MISSING_INFORMATION_HEADING"), messages: T }),
      /* @__PURE__ */ o("div", { className: m.buttonWrapper, children: [
        /* @__PURE__ */ r(
          q,
          {
            className: m.nextButton,
            label: e(d ? "BOOKING" : "BOOK"),
            onClick: L(k),
            iconRight: "ui-icon-arrow-right",
            isLoading: d
          }
        ),
        /* @__PURE__ */ r(
          K.Secondary,
          {
            className: m.backButton,
            label: e("BACK"),
            onClick: S,
            iconLeft: "ui-icon-arrow-left"
          }
        )
      ] })
    ] })
  ] });
};
export {
  Ue as PersonalInformation,
  Ue as default
};
